<div class="main-container">
<input #dateInput [attr.id]="inputId" [class]="'date-input ' + class" [ngModel]="value | dateFormat:format" (ngModelChange)="onModelChange($event)" (blur)="onBlur()" [placeholder]="placeholder" [disabled]="disabled">
<button class="generic-button clear-button" (click)="clear()" *ngIf="!this.disabled && calendarInfo.showClearButton"><i class="material-icons">clear</i></button>
</div>
